export default "__VITE_ASSET__9e9d7318__"